export const fontSize = {
  size10: '1rem',
  size12: '1.2rem',
  size14: '1.4rem',
  size15: '1.5rem',
  size16: '1.6rem',
  size18: '1.8rem',
  size20: '2rem',
  size22: '2.2rem',
  size24: '2.4rem',
  size36: '3.6rem',
  size40: '4rem',
  size50: '5rem'
};



// WEBPACK FOOTER //
// ./styles/core/fontSize.style.js